// extracted by mini-css-extract-plugin
module.exports = {"base":"Navigation_base__3UiRL"};